(function () {
  function formatMoney(cents, root) {
    var currency = root.dataset.currency || 'USD';
    var locale = root.dataset.locale || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }

  function initCart(root) {
    if (!root || root.dataset.siokiuuReady === 'true') return;
    root.dataset.siokiuuReady = 'true';

    function getLines() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-cart-line]'));
    }

    function setHeaderCartCount(count) {
      document.querySelectorAll('.siokiuu-home-header [data-cart-count]').forEach(function (item) {
        item.textContent = String(count);
        item.classList.toggle('is-empty', count < 1);
      });
    }

    function updatePreviewTotals() {
      var subtotal = 0;
      var count = 0;
      var totalOffset = Number(root.dataset.cartTotalOffsetCents || 0);

      getLines().forEach(function (line) {
        var price = Number(line.dataset.linePrice || 0);
        var input = line.querySelector('[data-qty-input]');
        var qty = Math.max(0, parseInt(input ? input.value : '0', 10) || 0);
        var lineTotal = price * qty;
        subtotal += lineTotal;
        count += qty;

        var subtotalNode = line.querySelector('[data-line-subtotal]');
        if (subtotalNode) subtotalNode.textContent = formatMoney(lineTotal, root);
      });

      var subtotalNode = root.querySelector('[data-summary-subtotal]');
      var totalNode = root.querySelector('[data-summary-total]');
      var countNode = root.querySelector('[data-summary-count]');

      if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal, root);
      if (totalNode) totalNode.textContent = formatMoney(Math.max(0, subtotal - totalOffset), root);
      if (countNode) countNode.textContent = String(count);
      setHeaderCartCount(count);
    }

    root.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var line = button.closest('[data-cart-line]');
        var input = line ? line.querySelector('[data-qty-input]') : null;
        if (!input) return;

        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        if (button.hasAttribute('data-qty-plus')) qty += 1;
        if (button.hasAttribute('data-qty-minus')) qty = Math.max(0, qty - 1);
        input.value = String(qty);
        updatePreviewTotals();
      });
    });

    root.querySelectorAll('[data-qty-input]').forEach(function (input) {
      input.addEventListener('change', updatePreviewTotals);
      input.addEventListener('input', updatePreviewTotals);
    });

    updatePreviewTotals();
  }

  function boot() {
    document.querySelectorAll('[data-siokiuu-cart]').forEach(initCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
